export default __webpack_public_path__ + "static/media/SmartphoneBlack.74d56374.svg";